<button (click)="onClick()" class="flex flex-row gap-2 group w-full hover:bg-gray-200 hover:bg-opacity-10 p-[2px] rounded-md items-center align-middle">
    <div class="w-6 h-6">
        <svg class="w-6 h-6 fill-none stroke-faded-70 group-hover:stroke-faded-90" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="getIconSvg()" />
        </svg>
    </div>
    <div>{{ label }}</div>
</button>